import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import FinalizeTpClientInvoiceItem from '../../../Domain/FinalizeTpClientInvoiceItem';
import TpClientInvoiceService from '../../../Services/TpClientInvoiceService';

export default class FinalizeTpClientInvoiceWindowDescription extends React.Component {
  static titleForEdit = (editedItem) => `Finalize Client Invoice (#${editedItem.TpClientInvoiceId})`;
  static finishButtonLabel = 'Finalize';
  static itemType = FinalizeTpClientInvoiceItem;
  static serviceFunction = TpClientInvoiceService.FinalizeInvoice;

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'FulfillmentDate',
          label: 'Fullfillment Date',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: FinalizeTpClientInvoiceWindowDescription.validateFulfillmentDate,
          hide: (item) => item.OfficeId !== 9,
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static validateFulfillmentDate(e, editedItem) {
    if (editedItem.OfficeId === 9) {
      const fulfillmentDate = new Date(e);
      const lowerLimit = new Date(dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(new Date(), 1)));
      const upperLimit = FinalizeTpClientInvoiceWindowDescription.calculateUpperLimit();
      if (fulfillmentDate < lowerLimit || fulfillmentDate >= upperLimit || e === 'NaN-NaN-NaN') {
        return "The date can't be before tomorrow or later than end of month + 60 days.";
      }
    }

    return '';
  }

  static calculateUpperLimit() {
    const year = new Date().getFullYear();
    const month = new Date().getMonth();
    const endOfMonth = new Date(year, month, dateTimeHelper.LastDayOfMonth(year, month));
    return dateTimeHelper.addDaysToDate(endOfMonth, 61);
  }
}
